import type { App } from 'vue'

import { isAbortLikeRequestError } from '@vben/request'

import * as Sentry from '@sentry/vue'

import {
  isDynamicImportFetchError,
  isRequestErrorCode,
  isRequestErrorStatus,
} from './sentry-error-filters'

/** 生产环境初始化 Sentry，并过滤可预期的噪音错误。 */
export function setupSentry(app: App) {
  if (import.meta.env.MODE === 'production') {
    console.log('MODE-success')
    Sentry.init({
      app,
      beforeSend(event, hint) {
        const originalException = hint.originalException

        // 用户主动取消/中断请求属于预期行为，不上报。
        if (isAbortLikeRequestError(originalException)) {
          return null
        }

        // 登录态不足相关错误属于业务预期，不上报。
        if (isRequestErrorStatus(originalException, [401, 403])) {
          return null
        }

        // 已知业务错误码属于可控异常，不上报。
        if (
          isRequestErrorCode(event, originalException, [7, 401, 403, 10_101])
        ) {
          return null
        }

        // 路由懒加载 chunk 拉取失败（版本切换/弱网）归类为噪音，过滤掉。
        if (isDynamicImportFetchError(event, originalException)) {
          return null
        }

        return event
      },
      dsn: 'https://a2f4531c89cde6f10d86913d3b79e411@o4509959913537536.ingest.us.sentry.io/4511058878529536',
      sendDefaultPii: true,
    })
  }
}
